const mediaQueryMobile = globalThis.matchMedia('(max-width: 815px)');
const isMobileBreakpoint = mediaQueryMobile.matches;

// validates if the URL is a local URL
function isLocalUrl(href) {
  const clientPath = SITEBASEURL;
  return href !== null && href.includes(clientPath);
}

function targetBlank(href) {
  return isLocalUrl(href) ? '' : 'target="_blank"';
}

export { mediaQueryMobile, isMobileBreakpoint, isLocalUrl, targetBlank };
